// Others
import axiosClient from './axiosClient';
import { urlApiActivity } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IActivity, IQueryParamActivity } from '~/utils/interface/activity';

const activityApi = {
  getActivityList: (params: IQueryParamActivity) => {
    const url = urlApiActivity.getActivityList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IActivity[]>>>(url, { params });
  },
};

export default activityApi;
